import { render, staticRenderFns } from "./GroupClassStatusPicker.vue?vue&type=template&id=72b7af06"
import script from "./GroupClassStatusPicker.vue?vue&type=script&lang=js"
export * from "./GroupClassStatusPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports